import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/amusementPlace`;

function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
    if (value != undefined && value != null)
      stringparams = stringparams + key + "=" + value + "&";
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}

const ApiAmusementPlace = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  create: (input) => {
    const url = `${baseServiceUrl}/create-amusementPlace`;
    return ServiceApi.post(url, input);
  },
  update: (id, data) => {
    const url = `${baseServiceUrl}/update-amusementPlace`;
    return ServiceApi.put(url, data);
  },
  delete: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.delete(url);
  }
  ,
  getPlaceByCityId: (params) => {
    const url = `${baseServiceUrl}/getPlaceByCityId`;
    return ServiceApi.put(url, params);
  },
};


export default ApiAmusementPlace;